import { __rest } from "tslib";
import React from 'react';
import { BtwText } from './BtwText';
function BtwHeading(props) {
    const { as, weight = 'bold', variant = 'primary' } = props, rest = __rest(props, ["as", "weight", "variant"]);
    return React.createElement(BtwText, Object.assign({ as: as, variant: variant, weight: weight }, rest));
}
export { BtwHeading };
